<!-- Slide Panel (Desktop) -->
<div 
  *ngIf="isOpen && mode === 'slide'"
  class="master-detail-panel slide-mode"
  [class.pinned]="isPinned"
  [class.resizing]="isResizing"
  [style.width.%]="currentWidth">
  
  <!-- Divisor Arrastável -->
  <div 
    class="panel-divider"
    (mousedown)="startResize($event)"
    title="Arraste para redimensionar">
    <div class="divider-handle">
      <i nz-icon nzType="drag" nzTheme="outline"></i>
    </div>
  </div>

  <!-- Header do Panel -->
  <div class="panel-header">
    <div class="panel-title">
      <i nz-icon nzType="form" nzTheme="outline"></i>
      <span>{{ panelTitle }}</span>
    </div>
    
    <div class="panel-actions">
      <!-- Botão Fixar -->
      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        [nz-tooltip]="isPinned ? 'Desafixar' : 'Fixar panel'"
        (click)="togglePin()">
        <i nz-icon [nzType]="isPinned ? 'pushpin' : 'pushpin'" [nzTheme]="isPinned ? 'fill' : 'outline'"></i>
      </button>
      
      <!-- Botão Fechar -->
      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        nz-tooltip="Fechar"
        (click)="close()">
        <i nz-icon nzType="close" nzTheme="outline"></i>
      </button>
    </div>
  </div>

  <!-- Conteúdo do Panel -->
  <div class="panel-content">
    <!-- Alerta se não há dados -->
    <nz-alert
      *ngIf="!selectedRowData"
      nzType="info"
      nzMessage="Nenhum registro selecionado"
      nzDescription="Selecione uma linha na grade para editar"
      nzShowIcon
      style="margin-bottom: 16px;">
    </nz-alert>

    <!-- ⭐ NOVO: Alerta informativo sobre origem dos campos virtuais -->
    <nz-alert
      *ngIf="selectedRowData && formFields.length > 0 && !formPanelId"
      nzType="info"
      nzMessage="✨ Campos gerados automaticamente da grade"
      nzShowIcon
      nzCloseable
      style="margin-bottom: 16px;">
      <div nz-alert-description>
        Os campos abaixo foram criados automaticamente a partir das colunas da grade. 
        Para personalizar, use <strong>"📝 Gerar Formulários Automaticamente"</strong> no gerador de telas.
      </div>
    </nz-alert>

    <!-- Formulário (sempre exibido quando há dados selecionados) -->
    <div *ngIf="selectedRowData && formFields.length > 0" class="form-container">
      <!-- ⭐ Renderizar campos dinamicamente -->
      <div *ngFor="let field of formFields" class="form-field-item">
        <label class="field-label">{{ getFieldLabel(field) }}</label>
        
        <!-- Campo de Texto -->
        <input 
          *ngIf="field.type === 'text'"
          nz-input 
          [placeholder]="getFieldPlaceholder(field)"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          class="field-input"
        />
        
        <!-- Campo Numérico -->
        <nz-input-number 
          *ngIf="field.type === 'number'"
          [nzMin]="getFieldProp(field, 'min')"
          [nzMax]="getFieldProp(field, 'max')"
          [nzStep]="getFieldProp(field, 'step') || 1"
          [nzPrecision]="getFieldProp(field, 'decimalPlaces') ?? 2"
          [nzAddonBefore]="getFieldProp(field, 'addonBefore')"
          [nzAddonAfter]="getFieldProp(field, 'addonAfter')"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          style="width: 100%;"
          class="field-input">
        </nz-input-number>
        
        <!-- Campo de Data -->
        <nz-date-picker 
          *ngIf="field.type === 'date'"
          [nzFormat]="getFieldProp(field, 'dateFormat') || 'dd/MM/yyyy'"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          style="width: 100%;"
          class="field-input">
        </nz-date-picker>
        
        <!-- Switch -->
        <nz-switch 
          *ngIf="field.type === 'switch'"
          [nzCheckedChildren]="getFieldProp(field, 'checkedChildren') || 'Sim'"
          [nzUnCheckedChildren]="getFieldProp(field, 'unCheckedChildren') || 'Não'"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          class="field-input">
        </nz-switch>
        
        <!-- Textarea -->
        <textarea 
          *ngIf="field.type === 'textarea'"
          nz-input 
          [rows]="getFieldProp(field, 'rows') || 4"
          [placeholder]="getFieldPlaceholder(field)"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          class="field-input">
        </textarea>
        
        <!-- Select -->
        <nz-select 
          *ngIf="field.type === 'select'"
          [nzPlaceHolder]="getFieldPlaceholder(field) || 'Selecione...'"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          style="width: 100%;"
          class="field-input">
          <nz-option 
            *ngFor="let option of getFieldProp(field, 'options') || []"
            [nzValue]="option.value"
            [nzLabel]="option.label">
          </nz-option>
        </nz-select>
      </div>
      
      <!-- Mensagem se não há campos -->
      <nz-alert
        *ngIf="formFields.length === 0"
        nzType="warning"
        nzMessage="Nenhum campo configurado"
        nzDescription="O painel de formulário não possui campos configurados"
        nzShowIcon>
      </nz-alert>
    </div>
  </div>

  <!-- Footer com Botões de Ação -->
  <div class="panel-footer" *ngIf="selectedRowData">
    <button 
      nz-button 
      nzType="default"
      (click)="cancel()">
      <i nz-icon nzType="close" nzTheme="outline"></i>
      Cancelar
    </button>
    
    <button 
      nz-button 
      nzType="primary"
      (click)="save()">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      Salvar
    </button>
  </div>
</div>

<!-- Bottom Sheet (Mobile/Tablet) -->
<div 
  *ngIf="isOpen && mode === 'sheet'"
  class="master-detail-panel sheet-mode"
  [class.minimized]="isMinimized"
  [class.pinned]="isPinned">
  
  <!-- Drag Handle (para arrastar sheet) -->
  <div class="sheet-handle" (click)="toggleMinimize()">
    <div class="handle-bar"></div>
  </div>

  <!-- Header do Sheet -->
  <div class="panel-header">
    <div class="panel-title">
      <i nz-icon nzType="form" nzTheme="outline"></i>
      <span>{{ panelTitle }}</span>
    </div>
    
    <div class="panel-actions">
      <!-- Botão Minimizar/Expandir -->
      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        (click)="toggleMinimize()">
        <i nz-icon [nzType]="isMinimized ? 'up' : 'down'" nzTheme="outline"></i>
      </button>
      
      <!-- Botão Fechar -->
      <button 
        nz-button 
        nzType="text" 
        nzSize="small"
        (click)="close()">
        <i nz-icon nzType="close" nzTheme="outline"></i>
      </button>
    </div>
  </div>

  <!-- Conteúdo do Sheet (oculto quando minimizado) -->
  <div class="panel-content" *ngIf="!isMinimized">
    <!-- Alerta se não há dados -->
    <nz-alert
      *ngIf="!selectedRowData"
      nzType="info"
      nzMessage="Nenhum registro selecionado"
      nzDescription="Selecione uma linha na grade para editar"
      nzShowIcon
      style="margin-bottom: 16px;">
    </nz-alert>

    <!-- ⭐ NOVO: Alerta informativo sobre origem dos campos virtuais -->
    <nz-alert
      *ngIf="selectedRowData && formFields.length > 0 && !formPanelId"
      nzType="info"
      nzMessage="✨ Campos gerados automaticamente da grade"
      nzShowIcon
      nzCloseable
      style="margin-bottom: 16px;">
      <div nz-alert-description>
        Os campos abaixo foram criados automaticamente a partir das colunas da grade. 
        Para personalizar, use <strong>"📝 Gerar Formulários Automaticamente"</strong> no gerador de telas.
      </div>
    </nz-alert>

    <!-- Formulário (sempre exibido quando há dados selecionados) -->
    <div *ngIf="selectedRowData && formFields.length > 0" class="form-container">
      <!-- ⭐ Renderizar campos dinamicamente -->
      <div *ngFor="let field of formFields" class="form-field-item">
        <label class="field-label">{{ getFieldLabel(field) }}</label>
        
        <!-- Campo de Texto -->
        <input 
          *ngIf="field.type === 'text'"
          nz-input 
          [placeholder]="getFieldPlaceholder(field)"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          class="field-input"
        />
        
        <!-- Campo Numérico -->
        <nz-input-number 
          *ngIf="field.type === 'number'"
          [nzMin]="getFieldProp(field, 'min')"
          [nzMax]="getFieldProp(field, 'max')"
          [nzStep]="getFieldProp(field, 'step') || 1"
          [nzPrecision]="getFieldProp(field, 'decimalPlaces') ?? 2"
          [nzAddonBefore]="getFieldProp(field, 'addonBefore')"
          [nzAddonAfter]="getFieldProp(field, 'addonAfter')"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          style="width: 100%;"
          class="field-input">
        </nz-input-number>
        
        <!-- Campo de Data -->
        <nz-date-picker 
          *ngIf="field.type === 'date'"
          [nzFormat]="getFieldProp(field, 'dateFormat') || 'dd/MM/yyyy'"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          style="width: 100%;"
          class="field-input">
        </nz-date-picker>
        
        <!-- Switch -->
        <nz-switch 
          *ngIf="field.type === 'switch'"
          [nzCheckedChildren]="getFieldProp(field, 'checkedChildren') || 'Sim'"
          [nzUnCheckedChildren]="getFieldProp(field, 'unCheckedChildren') || 'Não'"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          class="field-input">
        </nz-switch>
        
        <!-- Textarea -->
        <textarea 
          *ngIf="field.type === 'textarea'"
          nz-input 
          [rows]="getFieldProp(field, 'rows') || 4"
          [placeholder]="getFieldPlaceholder(field)"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          class="field-input">
        </textarea>
        
        <!-- Select -->
        <nz-select 
          *ngIf="field.type === 'select'"
          [nzPlaceHolder]="getFieldPlaceholder(field) || 'Selecione...'"
          [attr.data-component-id]="field.id"
          [ngModel]="getFieldValue(field)"
          (ngModelChange)="onFieldChange(field, $event)"
          style="width: 100%;"
          class="field-input">
          <nz-option 
            *ngFor="let option of getFieldProp(field, 'options') || []"
            [nzValue]="option.value"
            [nzLabel]="option.label">
          </nz-option>
        </nz-select>
      </div>
      
      <!-- Mensagem se não há campos -->
      <nz-alert
        *ngIf="formFields.length === 0"
        nzType="warning"
        nzMessage="Nenhum campo configurado"
        nzDescription="O painel de formulário não possui campos configurados"
        nzShowIcon>
      </nz-alert>
    </div>
  </div>

  <!-- Footer com Botões de Ação -->
  <div class="panel-footer" *ngIf="selectedRowData && !isMinimized">
    <button 
      nz-button 
      nzType="default"
      nzBlock
      (click)="cancel()">
      <i nz-icon nzType="close" nzTheme="outline"></i>
      Cancelar
    </button>
    
    <button 
      nz-button 
      nzType="primary"
      nzBlock
      (click)="save()">
      <i nz-icon nzType="save" nzTheme="outline"></i>
      Salvar
    </button>
  </div>
</div>

<!-- Backdrop (Escurece o fundo quando panel aberto) -->
<div 
  *ngIf="isOpen && !isPinned"
  class="panel-backdrop"
  (click)="close()">
</div>

